module.exports = __webpack_public_path__ + "img/icons_UI_icon_again.7b2cdd3f.svg";